<script lang="ts" setup>
import { RecorderErrors } from 'ui'
import { useForm } from '../state'

const form = useForm()
const error = form.state.error!
</script>

<template>
  <div class="p-4 gap-3 mx-auto max-w-500px h-full flex-col-center items-stretch">
    <section class="my-auto gap-2 grid">
      <div class="gap-3 flex items-center text-lg text-$color-primary xs:text-xl">
        <Icon name="mdi:alert-circle" class="text-[120%]" />
        <h3 class="font-semibold">
          {{ error.message }}
        </h3>
      </div>

      <p class="text-sm opacity-60">
        {{
          RecorderErrors.UploadFailed.matches(error)
            ? `This is most likely due to your internet speed being too slow to upload the file within 30 seconds. Download the file to make sure you don't lose it and try again.`
            : 'We have been notified about this issue. Please contact us if required.'
        }}
      </p>

      <footer class="mt-4 gap-3 grid xxs:grid-cols-2">
        <CTAButton variant="ghost" @click="form.reset">
          <Icon name="mdi:reload" /> Retry
        </CTAButton>

        <CTAButton variant="primary" @click="form.download">
          <Icon name="mdi:download" />
          Download Recording
        </CTAButton>
      </footer>
    </section>
  </div>
</template>

<style scoped lang="sass">
button[variant="ghost"]
  @apply text-$color-neutral bg-transparent border-1 border-solid border-$color-neutral-border hover:bg-$color-background-elevated
</style>
